import axios from "../services/axios";
import { LOCAL_STORAGE_TOKENS } from "../utils/constants";
const { localKey_refresh, localKey_access } = LOCAL_STORAGE_TOKENS;
const useRefreshToken = () => {
  const refresh = async () => {
    const response = await axios.post("/token/refresh/", {
      refresh: localStorage.getItem(localKey_refresh) || "",
    });
    localStorage.setItem(localKey_refresh, response.data.refresh);
    localStorage.setItem(localKey_access, response.data.access);
    return response.data.access;
  };

  return refresh;
};

export default useRefreshToken;
